import { isEUAwsRegion } from "../awsRegion";

// Keep this a leaf with no catalog imports: the Vite plugin that stamps
// environment.json reads it at config-load time, where connector logos can't parse.
export function openAIRegionalValue<T>(
  awsRegion: string | null | undefined,
  values: { eu: T; global: T; us: T }
): T {
  if (isEUAwsRegion(awsRegion)) return values.eu;
  if (awsRegion?.startsWith("us-")) return values.us;
  return values.global;
}

const OPENAI_BASE_URLS = {
  eu: "https://eu.api.openai.com/v1",
  global: "https://api.openai.com/v1",
  us: "https://us.api.openai.com/v1",
};

export function openAIRegionalBaseUrl(awsRegion: string | null | undefined) {
  return openAIRegionalValue(awsRegion, OPENAI_BASE_URLS);
}

export function openAIValueForBaseUrl<T>(
  baseUrl: string | undefined,
  values: { eu: T; global: T; us: T }
): T {
  if (baseUrl === OPENAI_BASE_URLS.eu) return values.eu;
  if (baseUrl === OPENAI_BASE_URLS.us) return values.us;
  return values.global;
}
